import styled from 'styled-components';

// Kept here because MerchantStorePage still imports Spacer from this module.
// All other styled components (brand/store list containers, images, etc.) were
// removed when the search UI was rebuilt with shadcn in PartnerHierarchyResults.
export const Spacer: any = styled.span`
  display: inline-block;
  width: ${(props: any) => props.width || 10}px;
`;
